<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableVirtualPrivateCloudResourceAzureListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableVirtualPrivateCloudResourceAzureVue = {};
export default {
  name: "TableVirtualPrivateCloudResourceAzure",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      subjectSearchKey: "",
      priorityId: "",
      columns: [
        {
          title: this.$t("RAM.Azure.VirtualNetwork.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.Azure.VirtualNetwork.subscriptionName"),
          key: "subscriptionName"
        },
        {
          title: this.$t("RAM.Azure.VirtualNetwork.subscriptionID"),
          key: "subscriptionId"
        },
        {
          title: this.$t("RAM.Azure.VirtualNetwork.resourceGroup"),
          key: "resourceGroupName"
        },
        {
          title: this.$t("RAM.Azure.VirtualNetwork.VPCName"),
          key: "vnName"
        },
        {
          title: this.$t("RAM.Azure.VirtualNetwork.location"),
          key: "location"
        },
        {
          title: this.$t("RAM.Azure.VirtualNetwork.addressSpace"),
          key: "addressSpace"
        }
        // {
        //     title: '子网名称',
        //     key: 'endTime'
        // },
        // {
        //     title: '自定义路由表',
        //     key: 'ticketEntityId'
        // },
        // {
        //     title: '防火墙',
        //     key: 'subject'
        // },
        // {
        //     title: '对等连接',
        //     key: 'createdBy'
        // },
        // {
        //     title: 'DNS',
        //     key: 'ticketCategoryName'
        // }
      ],
      tableVirtualPrivateCloudResourceAzureListData: []
    };
  },
  beforeCreate: function() {
    tableVirtualPrivateCloudResourceAzureVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableVirtualPrivateCloudResourceAzureVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableVirtualPrivateCloudResourceAzureVue.getVirtualPrivateCloudResourceAzureListData();
    },
    // 分页显示数据
    /****************************************************/
    getVirtualPrivateCloudResourceAzureListData: function() {
      this.$api.resourceManagement
        .pagingQueryAzureVirtualNetwork({
          companyId: this.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableVirtualPrivateCloudResourceAzureListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableVirtualPrivateCloudResourceAzureVue.getVirtualPrivateCloudResourceAzureListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableVirtualPrivateCloudResourceAzureVue.getVirtualPrivateCloudResourceAzureListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/vpc/TableVirtualPrivateCloudResourceAzure.vue